"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = require("../common/md5");
var Gravatar = /** @class */ (function () {
    function Gravatar() {
        this.md5Cache = {};
    }
    Gravatar.prototype.getUrl = function (email, size) {
        if (size === void 0) { size = 40; }
        email = email.toLowerCase();
        var cachedMd5 = this.md5Cache[email];
        if (!cachedMd5) {
            cachedMd5 = this.md5Cache[email] = md5_1.default(email || "");
        }
        return "https://en.gravatar.com/avatar/" + cachedMd5 + "?s=" + size + "&d=blank";
    };
    return Gravatar;
}());
exports.Gravatar = Gravatar;
exports.default = new Gravatar();
